export default "__VITE_ASSET__DRDT81vb__"